import './RoleCard.scss';
import { appSwitchRoutes } from 'constants/routes';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export type TRoleCardProps = {
  roleId: string;
  roleName: string;
  companyName: string;
  companyLogoUrl?: string | undefined;
  candidatePortalEnabled?: boolean;
};

const RoleCard: FC<TRoleCardProps> = ({
  roleId,
  roleName,
  companyName,
  companyLogoUrl,
  candidatePortalEnabled,
}) => {
  const { t } = useTranslation();

  return (
    <Link
      to={
        candidatePortalEnabled
          ? appSwitchRoutes.candidatePortal.getUrl(roleId)
          : appSwitchRoutes.role.getUrl(roleId)
      }
      className="RoleCard"
      aria-label={t('roles.roleAtCompany', { roleName, companyName })}
    >
      <div className="RoleCard__Logo">
        {companyLogoUrl ? (
          <img
            className="RoleCard__Logo__CompanyLogo"
            src={companyLogoUrl}
            alt={t('alt.companyLogo', { companyName })}
          />
        ) : (
          <span className="RoleCard__Logo__CompanyName">{companyName}</span>
        )}
      </div>
      <p className="RoleCard__Name">{roleName}</p>
      <p className="RoleCard__Company">{companyName}</p>
    </Link>
  );
};

export default RoleCard;
